<!-- ── Caso 1: checkbox singolo (boolean) ──────────────────────────────── -->
@if (isSingle) {
  <label
    class="checkbox-single"
    [class.checkbox-single--error]="control.invalid && control.touched"
    [class.checkbox-single--disabled]="control.disabled"
    [for]="baseId"
  >
    <input
      type="checkbox"
      class="checkbox__input"
      [id]="baseId"
      [formControl]="control"
    />
    <span class="checkbox__custom"></span>
    <span class="checkbox__label">
      {{ field.label }}
      @if (field.required) {
        <span class="required-asterisk" aria-hidden="true"> *</span>
      }
    </span>
  </label>
}

<!-- ── Caso 2: gruppo checkbox (array di valori) ───────────────────────── -->
@if (!isSingle) {
  <fieldset
    class="checkbox-group"
    [class.checkbox-group--error]="control.invalid && control.touched"
  >
    <legend class="checkbox-group__legend">
      {{ field.label }}
      @if (field.required) {
        <span class="required-asterisk" aria-hidden="true"> *</span>
      }
    </legend>

    @if (showSelectAll) {
      <label class="checkbox-select-all">
        <input
          type="checkbox"
          class="checkbox__input"
          [checked]="allSelected"
          [indeterminate]="someSelected"
          (change)="onSelectAllChange($any($event.target).checked)"
        />
        <span class="checkbox__custom"></span>
        <span class="checkbox__label">Seleziona tutte</span>
      </label>
    }

    @if (showFilter) {
      <div class="checkbox-group__filter" role="radiogroup" aria-label="Filtra elenco ditte">
        <label class="filter-option">
          <input
            type="radio"
            class="filter-option__input"
            name="{{ baseId }}-filter"
            [checked]="filterMode() === 'all'"
            (change)="setFilterMode('all')"
          />
          <span class="filter-option__label">Tutte</span>
        </label>
        <label class="filter-option">
          <input
            type="radio"
            class="filter-option__input"
            name="{{ baseId }}-filter"
            [checked]="filterMode() === 'selected'"
            (change)="setFilterMode('selected')"
          />
          <span class="filter-option__label">Solo ditte associate</span>
        </label>
        <label class="filter-option">
          <input
            type="radio"
            class="filter-option__input"
            name="{{ baseId }}-filter"
            [checked]="filterMode() === 'unselected'"
            (change)="setFilterMode('unselected')"
          />
          <span class="filter-option__label">Solo ditte non associate</span>
        </label>
      </div>
    }

    <div class="checkbox-group__options" [class.checkbox-group__options--list]="isListMode">
      @for (option of visibleOptions; track option.value; let i = $index) {
        <label
          class="checkbox-option"
          [class.checkbox-option--disabled]="option.disabled || control.disabled"
          [class.checkbox-option--salvata]="isSalvata(option.value)"
          [for]="optionId(i)"
        >
          <input
            type="checkbox"
            class="checkbox__input"
            [id]="optionId(i)"
            [checked]="isChecked(option.value)"
            (change)="onMultiChange(option.value, $any($event.target).checked)"
          />
          <span class="checkbox__custom"></span>
          <span class="checkbox__label">
            {{ option.label }}
            @if (isSalvata(option.value)) {
              <span class="sr-only">(già associata)</span>
            }
          </span>
        </label>
      }
      @if (showFilter && visibleOptions.length === 0) {
        <p class="checkbox-group__empty">Nessuna ditta corrisponde al filtro selezionato.</p>
      }
    </div>

    <!-- Legenda del grassetto: solo se c'è almeno un'associazione salvata,
         altrimenti spiegherebbe qualcosa che nell'elenco non compare. -->
    @if (hasValoriSalvati) {
      <p class="checkbox-group__nota">Le ditte in grassetto sono quelle già associate.</p>
    }
  </fieldset>
}
